import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail, LOGO_URL } from "@/lib/api";
import { Loader2, Lock } from "lucide-react";

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      nav("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-900 grain relative flex items-center justify-center px-4" data-testid="admin-login-page">
      <div className="w-full max-w-md relative">
        <div className="flex flex-col items-center mb-8">
          <img src={LOGO_URL} alt="logo" className="h-16 w-16 object-contain bg-white rounded-2xl p-2 mb-4" />
          <h1 className="font-display text-2xl font-extrabold text-white">Espace propriétaire</h1>
          <p className="text-sm text-slate-400 mt-1">Les Yeux Dans L'Immo</p>
        </div>
        <form onSubmit={submit} className="bg-white rounded-2xl p-8 shadow-2xl">
          <div className="mb-4">
            <label className="block text-sm font-medium text-slate-700 mb-2">Email</label>
            <input
              type="email" value={email} onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-email-input" required
              className="w-full bg-slate-50 border border-slate-200 rounded-lg px-4 py-3 focus:ring-2 focus:ring-[#2563EB] outline-none"
            />
          </div>
          <div className="mb-6">
            <label className="block text-sm font-medium text-slate-700 mb-2">Mot de passe</label>
            <input
              type="password" value={password} onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-password-input" required
              className="w-full bg-slate-50 border border-slate-200 rounded-lg px-4 py-3 focus:ring-2 focus:ring-[#2563EB] outline-none"
            />
          </div>
          {error && <div className="mb-4 text-sm text-red-600 bg-red-50 rounded-lg px-4 py-2" data-testid="admin-error">{error}</div>}
          <button
            type="submit" disabled={loading}
            data-testid="admin-login-btn"
            className="w-full flex items-center justify-center gap-2 bg-[#2563EB] text-white hover:bg-blue-700 disabled:opacity-60 px-6 py-3 rounded-lg font-semibold transition-all"
          >
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Lock className="w-4 h-4" />}
            Se connecter
          </button>
        </form>
      </div>
    </div>
  );
}
